export default __webpack_public_path__ + "static/media/broujLogo_.9e82d861.png";